import React, { useEffect, useState } from 'react';
import Btn from '../../../components/ui/Btn';
import Modal from '../../../components/ui/Modal';
import Field, { TextInput } from '../../../components/ui/Field';
import { AGENT_NAME_MAX, checkAgentName } from '../../../utils/agentName';

/** Cambiar el nombre de un agente. Solo cambia el nombre: el agente, sus versiones y sus canales siguen igual. `onSave(nombre)` guarda. */
export default function RenameAgentModal({ open, onClose, agent, onSave }) {
  const [value, setValue] = useState('');
  const [touched, setTouched] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { if (open) { setValue(agent?.name || ''); setTouched(false); setError(''); } }, [open, agent?.name]);

  const check = checkAgentName(value, agent?.name);
  const shown = touched ? check.error : '';

  const save = async (e) => {
    e?.preventDefault();
    setTouched(true);
    if (check.error) return;
    setBusy(true); setError('');
    try { await onSave(check.name); onClose(); }
    catch (err) { setError(err.message || 'No se pudo cambiar el nombre.'); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="Cambiar el nombre del agente"
      description="Es el nombre con el que tu equipo lo reconoce. No cambia lo que el agente responde ni sus canales."
      footer={<><Btn variant="ghost" onClick={onClose} disabled={busy}>Cancelar</Btn><Btn variant="primary" onClick={save} loading={busy} disabled={Boolean(check.error) && touched}>Guardar nombre</Btn></>}>
      <form onSubmit={save} noValidate>
        <Field label="Nombre del agente" error={shown || error}>
          <TextInput value={value} onChange={(e) => { setValue(e.target.value); setTouched(true); }} maxLength={AGENT_NAME_MAX} autoComplete="off" data-autofocus />
        </Field>
      </form>
    </Modal>
  );
}
